import React from 'react'
import { Instagram, Linkedin, Pinterest, Tiktok, Youtube, Headphones } from "react-bootstrap-icons";

export const providerLogo = (provider) => {
  switch(provider) {
    case "instagram":
      return <Instagram className='text-pink-400' />
      break;
    case "tiktok":
      return <Tiktok />
      break;
    case "youtube":
      return <Youtube className='text-red-500' />
      break;
    case "pinterest":
      return <Pinterest className='text-red-700' />
      break;
    case "linkedin":
      return <Linkedin className='text-blue-600' />
      break;
    case "podcast":
      return <Headphones className='text-gray-700 dark:text-gray-300' />
      break;
  }
}

export const formatProvider = (provider) => {
  switch(provider) {
    case "instagram":
      return "Instagram"
      break;
    case "tiktok":
      return "TikTok"
      break;
    case "youtube":
      return "YouTube"
      break;
    case "pinterest":
      return "Pinterest"
      break;
    case "linkedin":
      return "LinkedIn"
      break;
    case "podcast":
      return "Podcast"
      break;
  }
}
export const formatNumber = (num, decimals = 1) => {
  // Kezeljük a null, undefined, és nem szám értékeket
  if (num === null || num === undefined || isNaN(num)) {
    return '0';
  }

  const number = Number(num);

  if (number >= 1000000) {
    return (number / 1000000).toFixed(decimals) + 'M';
  } else if (number >= 1000) {
    return (number / 1000).toFixed(decimals) + 'K';
  }

  return number.toString();
}

export const currencyUnit = (currency_symbol) => {
  if(currency_symbol === 'EUR') {
    return '€'
  } else if(currency_symbol === 'USD') {
    return '$'
  } else {
    return currency_symbol
  }
}

export const separateThousands = (number) => {
  if (number === undefined || number === null) {
    return '0';
  }

  const germanNumber = number.toString().replace('.', ',');
  return germanNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export const currencyFormat = (number, currency_symbol='') => {
  return `${currencyUnit(currency_symbol)} ${separateThousands(number)}`
}

/** Pénznem formátum: >= 1000 esetén "x.xxk €", különben currencyFormat. */
export const formatCurrencyKpi = (number, currency_symbol = '') => {
  const num = Number(number)
  if (isNaN(num)) return currencyFormat(number, currency_symbol)
  if (num >= 1000) {
    const k = (num / 1000).toFixed(2).replace(/\.?0+$/, '')
    return `${currencyUnit(currency_symbol)} ${k}k`
  }
  return currencyFormat(number, currency_symbol)
}

export const socialPlatformLink = (provider, username) => {
  const handle = (username || '').replace(/^@/, '')
  switch(provider) {
    case "instagram":
      return `https://www.instagram.com/${handle}`
      break;
    case "tiktok":
      return `https://www.tiktok.com/@${handle}`
      break;
    case "youtube":
      return `https://www.youtube.com/@${handle}`
      break;
    case "linkedin":
      return `https://www.linkedin.com/in/${handle}/`
      break;
  }
}